import { ThemeUICSSObject, spacing } from '@apia/theme';

const selectBox: ThemeUICSSObject = {
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'palette.border.field',
  display: 'inline-flex',
  flexDirection: 'row',
  gap: spacing(3),
  p: spacing(3),
  width: '100%',

  '& > label': {
    flexShrink: 0,
    maxWidth: '33%',
  },

  '& > div': {
    flexGrow: 1,
  },
};

export default selectBox;
